"use strict";

define(['marionette', 'backbone', './views/topicLayoutView'], function (Marionette, Backbone, topicView) {
  return Marionette.CollectionView.extend({
    tagName: 'ul',
    options: {
      avatarSize: 'm',
      showCategory: true
    },
    childViewOptions: function childViewOptions() {
      return {
        avatarSize: this.getOption('avatarSize'),
        showCategory: this.getOption('showCategory')
      };
    },
    className: 'list',
    childView: topicView,
    initialize: function initialize(options) {
      var isTopicsBackboneCollection = options.topics instanceof Backbone.Collection;

      if (!isTopicsBackboneCollection) {
        options.topics = new Backbone.Collection(options.topics);
      }

      this.collection = options.topics;
      this.listenTo(this.collection, 'all', this.render);
    }
  });
});